import { option, pipe } from '@code-expert/prelude';
import type { SetPageParams } from '/imports/ui/navigation/pageParams';
import { PageParams, updatePageParams } from '/imports/ui/navigation/pageParams';
import { UiState } from '/imports/utils/UiState';

export const pageParamUiStates = UiState.valueProp('pageParams', PageParams);

export const setPageParamsUiState = (params: SetPageParams) => {
  pageParamUiStates.modify(updatePageParams(params));
};

export const clearPageParamsUiState = () => {
  pageParamUiStates.clear();
};

export const useGetPageParamsUiState = <K extends keyof PageParams>(
  key: K,
): option.Option<Required<PageParams>[K]> =>
  pipe(
    option.fromNullable(pageParamUiStates.get()),
    option.chainNullableK((s) => s[key]),
  );
